var _path, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaidState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 34,
    viewBox: "0 0 612 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 4H108V24C108 28.714 108 31.0711 106.536 32.5355C105.071 34 102.714 34 98 34H46C41.286 34 38.9289 34 37.4645 32.5355C36 31.0711 36 28.714 36 24V4Z",
    fill: "#15A612"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3752 24V14.07H57.8452C58.9052 14.07 59.7402 14.36 60.3502 14.94C60.9602 15.51 61.2652 16.285 61.2652 17.265C61.2652 18.245 60.9602 19.025 60.3502 19.605C59.7402 20.175 58.9052 20.46 57.8452 20.46H54.5002V24H53.3752ZM54.5002 19.41H57.7702C58.5502 19.41 59.1402 19.22 59.5402 18.84C59.9402 18.46 60.1402 17.935 60.1402 17.265C60.1402 16.605 59.9402 16.085 59.5402 15.705C59.1402 15.325 58.5502 15.135 57.7702 15.135H54.5002V19.41ZM63.3468 24L67.5618 14.07H68.9718L73.1868 24H71.9418L70.7268 21.12H65.8068L64.5918 24H63.3468ZM66.2418 20.085H70.2918L68.2668 15.24L66.2418 20.085ZM76.6984 24V14.07H77.8234V24H76.6984ZM82.508 24V14.07H86.693C87.283 14.07 87.848 14.185 88.388 14.415C88.938 14.635 89.428 14.96 89.858 15.39C90.288 15.82 90.628 16.34 90.878 16.95C91.128 17.56 91.253 18.255 91.253 19.035C91.253 19.815 91.128 20.51 90.878 21.12C90.628 21.73 90.288 22.25 89.858 22.68C89.428 23.11 88.938 23.44 88.388 23.67C87.848 23.89 87.283 24 86.693 24H82.508ZM83.633 22.935H86.648C87.358 22.935 87.973 22.755 88.493 22.395C89.013 22.035 89.413 21.56 89.693 20.97C89.983 20.38 90.128 19.735 90.128 19.035C90.128 18.325 89.983 17.675 89.693 17.085C89.413 16.495 89.013 16.025 88.493 15.675C87.973 15.315 87.358 15.135 86.648 15.135H83.633V22.935Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 610,
    y2: 2,
    stroke: "#15A612",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidState);
export default __webpack_public_path__ + "static/media/paid-state.511aed65.svg";
export { ForwardRef as ReactComponent };